export const GOAL_STATUS_NODES = [
  {
    color: {
      dark: '#B1E39F',
      light: '#B1E39F',
    },
    id: 'ON_TRACK',
    name: 'On-Track',
  },
  {
    color: {
      dark: '#FFDE88',
      light: '#FFDE88',
    },
    id: 'OFF_TRACK',
    name: 'Off-Track',
  },
  {
    color: {
      dark: '#FAD4D4',
      light: '#FAD4D4',
    },
    id: 'AT_RISK',
    name: 'At-Risk',
  },
  {
    color: {
      dark: '#B1E39F',
      light: '#B1E39F',
    },
    id: 'ACHIEVED',
    name: 'Closed & achieved',
  },
  {
    color: {
      dark: '#FCC88B',
      light: '#FCC88B',
    },
    id: 'NOT_ACHIEVED',
    name: 'Closed & not achieved',
  },
  {
    color: {
      dark: '#FFAE99',
      light: '#FFAE99',
    },
    id: 'DROPPED',
    name: 'Closed & dropped',
  },
  {
    color: {
      dark: '#FFAE99',
      light: '#FFAE99',
    },
    id: 'CLOSED',
    name: 'Closed',
  },
];

export const ONE_ON_ONE_STATUS_NODES = [
  {
    color: {
      dark: '#B1E39F',
      light: '#B1E39F',
    },
    id: 'COMPLETED',
    name: 'Completed',
  },
  {
    color: {
      dark: '#FFAE99',
      light: '#FFAE99',
    },
    id: 'CANCELLED',
    name: 'Cancelled',
  },
];
